export const questionFrontEndNames = [
	"kizi",
	"overstappen",
	"swift",
] as const;
export type QuestionFrontEndName = typeof questionFrontEndNames[number];
